import React from 'react';
import {
  Row,
  Col,
  Divider,
  Input,
  Typography,
  Form,
  Button,
  DatePicker,
  message,
  Select,
  Result,
  Skeleton
} from 'antd';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../config/axios';
import AddTransferItems from './components/AddTransferItems';
import TransferItems from './components/TransferItems';

// const transferTypes = [
//   { key: '1', label: 'โอนเข้า', value: 'TRANSIN' },
//   { key: '2', label: 'โอนออก', value: 'TRANSOUT' },
// ]
function Transfer() {

  const [messageApi, contextHolder] = message.useMessage();
  const [form] = Form.useForm();

  const lastNumberQuery = useQuery({ queryKey: ['/api/transaction/getLastTransfered'] });
  const employeeQuery = useQuery({ queryKey: ['/api/employee/'] });
  const warehouseQuery = useQuery({ queryKey: ['/api/warehouse/getActiveWarehouse'] });
  const productQuery = useQuery({ queryKey: ['/api/product/getActiveProducts'] });
  const cartItemQuery = useQuery({ queryKey: ['/api/cartItem/getTransferCartItems'] });
  const queryClient = useQueryClient();
  const redirect = useNavigate();

  const { isLoading, mutate } = useMutation({
    mutationFn: data => {
      axios
        .post('/api/transaction/createTransaction', data)
        .then(res => {
          // console.log("create customer :",res);
          messageApi.open({
            type: 'success',
            content: 'บันทึกข้อมูลสำเร็จ',
            duration: 1,
            onClose: () => {
              queryClient.invalidateQueries(['/api/transaction/getLastTransfered']);
              redirect(`/admin/transactions/${res.data._id}`);
            }
          });
        })
        .catch(err => {
          console.log(err)
          messageApi.open({
            type: 'error',
            content: 'ไม่สามารถบันทึกข้อมูลได้ ข้อมูลไม่ถูกต้อง',
          });
        })
    },
  });


  const onFinish = (values) => mutate(
    {
      ...values,
      shipment_date:dayjs(),
      transaction_type:'TRANSOUT',
      transactionItems: cartItemQuery.data.map(item => ({ ...item, product: item.product.id })),
      payment_type: "NA"
    });
  // const onFinish = (values) => mutate(values);

  if (
    employeeQuery.isLoading
    || warehouseQuery.isLoading
    || productQuery.isLoading
    || cartItemQuery.isLoading
    || lastNumberQuery.isLoading
  ) {
    return <Skeleton active />
  }

  if (
    employeeQuery.isError
    || warehouseQuery.isError
    || productQuery.isError
    || cartItemQuery.isError
    || lastNumberQuery.isError
  ) {
    return <Result
      status="error"
      title={
        employeeQuery.error.message
        || warehouseQuery.error.message
        || productQuery.error.message
        || cartItemQuery.error.message
        || lastNumberQuery.error.message
      }
    />
  };

  // console.log("lastNumberQuery", lastNumberQuery.data)
  // console.log("vendorQuery", vendorQuery.data)
  // console.log("warehouseQuery", warehouseQuery.data)
  // console.log("productQuery", productQuery.data)
  // console.log("cartItemsQuery", cartItemQuery.data)
  // console.log("transferItems", transferItems)

  return (
    <div style={{
      background: '#fff',
    }}>
      {contextHolder}
      <Row justify='space-between' >
        <Col xs={24} md={12} >
          <Typography.Title level={3}>
            บันทึกการโอนสินค้า
          </Typography.Title>
        </Col>
        <Divider />
        <Col xs={24}>
          <Form
            name="createTransaction"
            layout="vertical"
            form={form}
            onFinish={onFinish}
            initialValues={{
              doc_no: lastNumberQuery.data,
              order_date: dayjs(),
            }}
          >
            <Row>
              <Col xs={24} md={16}>
                <Row gutter={[8, 8]}>
                  <Col xs={24} md={12}>
                    <Form.Item
                      label="เลขที่เอกสาร"
                      name="doc_no"
                      rules={[
                        {
                          required: true,
                          message: 'กรุณากรอกข้อมูล!',
                        },
                      ]}
                    >
                      <Input disabled style={{ background: "#FFF", color: "#000" }} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item
                      label="วันที่"
                      name="order_date"
                      rules={[
                        {
                          required: true,
                          message: 'กรุณากรอกข้อมูล!',
                        },
                      ]}
                    >
                      <DatePicker style={{ width: "100%" }} format={'DD-MM-YYYY'} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item
                      shouldUpdate
                      label="โอนไปยังสาขา"
                      name="customer"
                      rules={[
                        {
                          required: true,
                          message: 'กรุณากรอกข้อมูล!',
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        optionFilterProp="children"
                      >
                        {warehouseQuery.data.map((warehouse) => (
                          <Select.Option key={warehouse._id} value={warehouse._id} >
                            {warehouse.company}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item
                      label="ผู้ดำเนินการ"
                      name="employee"
                      rules={[
                        {
                          required: true,
                          message: 'กรุณากรอกข้อมูล!',
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        optionFilterProp="children"
                      >
                        {employeeQuery.data.map((emp) => (
                          <Select.Option key={emp._id} value={emp._id} >
                            {emp.fname}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24}>
                    <Form.Item name="description" label="รายละเอียด">
                      <Input.TextArea rows={2} />
                    </Form.Item>
                  </Col>
                  <Col xs={24}>
                    <AddTransferItems
                      products={productQuery.data}
                    />
                  </Col>
                  <Col xs={24}>
                    <TransferItems
                      products={cartItemQuery.data}
                    />
                  </Col>
                  <Col xs={24} >
                    <Row justify="end">
                      <Col>
                        <Form.Item>
                          <Button type="primary" htmlType="submit" disabled={isLoading}>
                            บันทึก
                          </Button>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </div>
  )
}

export default Transfer